import { cloneElement } from "react";
import { Badge } from "@/shared/ui";
import type { BadgeColor } from "@/shared/ui";
import type { ProjectDetail } from "../../../types";
import PartnersBadge from "./PartnersBadge";

interface HeroProps {
  project: ProjectDetail;
  statusInfo: { label: string; color: BadgeColor };
  categoryLabel: string;
  categoryIcon?: React.ReactNode;
  t: (key: string, opts?: Record<string, unknown>) => string;
}

export default function HeroSection({ project, statusInfo, categoryLabel, categoryIcon, t }: HeroProps) {
  return (
    <div className="relative w-full h-95 radius-3xl overflow-hidden">
      <div className="relative w-full h-full">
        {project.project_picture_url ? (
          <img
            src={project.project_picture_url}
            alt={project.name}
            className="absolute top-0 left-0 w-full h-full z-0 object-cover"
          />
        ) : (
          <div className="absolute top-0 left-0 w-full h-full z-0 bg-gradient-to-br from-blue-100 to-purple-100" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />

        <div className="flex flex-col justify-between h-full p-6 gap-5">
          <div className="flex flex-wrap gap-2 z-10">
            <Badge variant="soft" color={statusInfo.color} text={t(statusInfo.label)} dot />
            {categoryLabel && (
              <Badge
                variant="filled"
                color="info"
                text={categoryLabel}
                icon={categoryIcon ? cloneElement(categoryIcon as React.ReactElement<{ size?: number }>, { size: 16 }) : undefined}
              />
            )}
            {project.partners.length > 0 && <PartnersBadge partners={project.partners} t={t} />}
          </div>

          <div className="flex flex-col gap-4 z-10">
            <h1 className="text-display-xs text-white">{project.name}</h1>
            <p className="text-body-regular-md text-white">{project.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
